<template>
  <div class="empty">
    <slot>
      {{ ct }}
    </slot>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ct: this.$t('common.noResult')
    }
  },
  created() {
    this.ct = this.content ? this.content : this.$t('common.noResult')
  }
}
</script>

<style lang="scss" scoped>
.empty {
  user-select: none;
  line-height:300px;
  text-align: center;
  color: #909399;
  font-size: 12px;
  height: 300px;
}

</style>
